import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Router } from '@angular/router';
import { AppStateService } from '@app/shared/services/app-state.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
@Injectable()
export class HomeRoutingGuardService {
  state = true;
  userdetails;
  public loginState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  constructor(private appState: AppStateService, private router: Router) {
    // this.appState.logoutState.subscribe(response => {
    //   this.state = response;
    //
    // });
  }

  canActivate() {
    if (window.localStorage.getItem('logoutStatus') === 'false') {
      if (
        JSON.parse(window.localStorage.getItem('userDetails'))['roles']['0'][
          'code'
        ] === 'tech_buyer'
      ) {

        this.appState.setState(true);
        this.router.navigate(['tech-buyer']);
      } else if (
        JSON.parse(window.localStorage.getItem('userDetails'))['roles']['0'][
          'code'
        ] === 'tech_vendor'
      ) {

        this.appState.setState(true);
        this.router.navigate(['tech-vendor']);
      } else {
        this.appState.setState(false);

        return true;
      }
    } else {
      this.appState.setState(false);

      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/Home-guard.service.ts